import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { msg } from '@lingui/core/macro';
import { ceeElectricityUsageFields } from './common/electricityFields';

export const ceeElectricityUsageScope33WttTdLossMetadata = {
  displayName: msg({
    message: 'CEE Electricity Usage Scope 3.3 WTT TD Loss',
    context:
      'Activity data schema name for CEE Electricity Usage Scope 3.3 WTT TD Loss',
  }),
  fields: {
    ...coreFields,
    ...ceeElectricityUsageFields,
  },
} as const satisfies BatMetadataConfigEntry;
